import React from 'react';
import { TextInput, SelectInput } from 'react-admin';

import Edit from '../common/views/Edit';
import SimpleForm from '../common/forms/SimpleForm';
import { industryChoices } from '../common/constants/industryChoices';

const CustomerEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="name" />
            <TextInput source="short_name" />
            <SelectInput source="industry" label="Industry" choices={industryChoices} />
            <TextInput source="description" multiline fullWidth rows="4" />
        </SimpleForm>
    </Edit>
);

export default CustomerEdit;
